import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CASE_STUDIES_INDEX } from "@/data/caseStudies";
import SEO, { breadcrumbJsonLd } from "@/components/SEO";

const ORDER = [
  ["background", "Background"],
  ["history", "History of Loss"],
  ["inspection", "Inspection"],
  ["moisture", "Moisture Findings"],
  ["thermal", "Thermal Images"],
  ["sampling", "Environmental Sampling"],
  ["lab", "Laboratory Results"],
  ["interpretation", "Interpretation"],
  ["recommendations", "Recommendations"],
  ["protocol", "Protocol"],
  ["lessons", "Lessons Learned"],
];

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const c = CASE_STUDIES_INDEX[slug];

  if (!c) {
    return (
      <div className="container-x py-32 text-center">
        <h1 className="font-display text-3xl font-bold">Case study not found</h1>
        <Link to="/case-studies" className="btn-primary mt-8 inline-flex">Case studies</Link>
      </div>
    );
  }

  return (
    <div data-testid="case-detail-page">
      <SEO
        title={c.title}
        description={c.summary}
        path={`/case-studies/${c.slug}`}
        jsonLd={breadcrumbJsonLd([
          { name: "Home", path: "/" },
          { name: "Case Studies", path: "/case-studies" },
          { name: c.title, path: `/case-studies/${c.slug}` },
        ])}
      />
      <section className="bg-[#0F172A] text-white py-20">
        <div className="container-x max-w-4xl">
          <Link to="/case-studies" className="text-white/60 hover:text-white text-sm inline-flex items-center gap-2 mb-8">
            <ArrowLeft className="w-4 h-4" /> All case studies
          </Link>
          <div className="overline text-[#F59E0B] mb-4">{c.industry} • {c.location}</div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight">{c.title}</h1>
          <p className="mt-6 text-lg text-white/70 max-w-3xl leading-relaxed">{c.summary}</p>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x max-w-4xl space-y-12">
          {ORDER.map(([k, label]) => (
            <div key={k}>
              <div className="overline mb-3">{label}</div>
              <p className="text-lg text-slate-700 leading-relaxed">{c.sections[k]}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
